(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/constants.js');

'use strict';


const DRAW_STATES = {
  DEFINED: 1,
  OPEN: 2,
  CLOSED: 3
};
const CURRENT_DRAW_PATHS = {
  eurojackpot: '/draw/2/eurojackpot/draws',
  eurojackpottuesday: '/draw/2/eurojackpot/draws',
  eurojackpotfriday: '/draw/2/eurojackpot/draws',
  keno: '/draw/1/keno/draws',
  lotto: '/draw/1/lotto/draws',
  lottowednesday: '/draw/1/lotto/draws',
  lottosaturday: '/draw/1/lotto/draws',
  vikinglotto: '/draw/1/vikinglotto/draws',
  jokerwednesday: '/draw/1/jokerwednesday/draws',
  jokersaturday: '/draw/1/jokersaturday/draws'
};
if (svs.isServer) {
  module.exports = {
    DRAW_STATES,
    CURRENT_DRAW_PATHS
  };
} else {
  svs.numbergames.draws.constants = {
    DRAW_STATES,
    CURRENT_DRAW_PATHS
  };
}

 })(window);